function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#0085FF",
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 8h8m-4 4V4",
  stroke: "#FFF",
  strokeWidth: 2,
  strokeLinecap: "round"
}));
function SvgNoteAddBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
}
export default SvgNoteAddBlue;